module.exports = __webpack_public_path__ + "img/wa-round-gray-icon.201ed347.svg";